import React from "react";
import "./IndexPage.css";
import TopicFrame from "../../components/TopicFrame/TopicFrame";
import TopicsGrid from "./../../components/TopicsGrid/TopicsGrid";
import topicsData from "./../../assets/json/themenBeschreibungen.json";

const IndexPage = () => {
  return (
    <>
      {Object.keys(topicsData).map(section => (
        <TopicFrame Title={section.toUpperCase()}>
        <TopicsGrid>
          {topicsData[section].map((topic, index) => (
            <a href={topic.link} key={index}>
              <div className="gridContainer hoverable">
                <div className="Themenueberschrift">{topic.title}</div>
                <div className="Themenbeschreibung">
                  <img src={require(`./../../assets/images/index/${topic.image}.jpg`)} alt="Platzhalter" />
                  <div>{topic.description}</div>
                </div>
              </div>
            </a>
          ))}
        </TopicsGrid>
      </TopicFrame>
      ))}
    </>
  );
};

export default IndexPage;
